import { useTranslation } from 'react-i18next';
import { ShieldAlert } from 'lucide-react';

/**
 * Suspended state (state-routing polish) — a distinct red/amber card shown when
 * the merchant's FFC program `status === 'suspended'`. Deliberately does NOT
 * render the State B branch-onboarding steps (visiting a branch does not apply
 * to a suspended account); it directs the merchant to support instead.
 */
function AdvanceSuspendedCard() {
  const { t } = useTranslation();
  return (
    <div
      className='mx-auto mt-2 max-w-[720px] rounded-2xl border border-solid border-[#F1C6BE] bg-[#FBEAE7] px-10 py-9'
      data-testid='advance-cod-suspended-card'
    >
      <div className='flex items-center gap-3'>
        <span className='inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#F7D6CF]'>
          <ShieldAlert className='h-[22px] w-[22px] text-[#C0392B]' strokeWidth={2} />
        </span>
        <div>
          <div className='text-[19px] font-extrabold tracking-[-0.3px] text-[#8A2A1E]'>
            {String(t('advance_cod_suspended_card_title'))}
          </div>
          <div className='mt-1 text-[13.5px] leading-[1.5] text-[#9A5449]'>
            {String(t('advance_cod_suspended_card_body'))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdvanceSuspendedCard;
